<script>
  import { Tween } from 'svelte/motion';
  import { cubicOut } from 'svelte/easing';

  let {
    xValue,
    yValue,
    r = 10,
    fill = 'white',
    stroke,
    strokeWidth,
    opacity,
    i,
    animate = 'beeswarm'
  } = $props();

  const tweenParams = {
    delay: 300 + 10 * i,
    duration: 250,
    easing: cubicOut
  };

  let tY = new Tween(0, tweenParams);

  $effect(() => {
    if (animate === 'beeswarm') {
      tY.set(+yValue);
    } else if (animate === 'one-dimensional') {
      tY.set(0);
    }
  });
</script>

<circle
  pointer-events="none"
  cx={xValue}
  cy={tY.current}
  {opacity}
  {fill}
  {stroke}
  stroke-width={strokeWidth}
  {r} />
